import React from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";

const LocationLayout = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Outlet />
      {/* In-app navigation keeps the scroll position otherwise */}
      <ScrollRestoration />
    </div>
  );
};

export default LocationLayout;
